var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquipment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3809 0.344523C15.6049 0.692951 15.504 1.15699 15.1556 1.38098L3.30361 9.00009H7.5V8.25009C7.5 7.28359 8.2835 6.50009 9.25 6.50009H12.5V5.75009C12.5 4.78359 13.2835 4.00009 14.25 4.00009H17.25C18.2165 4.00009 19 4.78359 19 5.75009V9.00009H19.25C19.6642 9.00009 20 9.33588 20 9.75009V16.7501C20 18.545 18.5449 20.0001 16.75 20.0001H3.25C1.45507 20.0001 0 18.545 0 16.7501V9.75009C0 9.49489 0.129765 9.25721 0.344432 9.11921L14.3444 0.119207C14.6929 -0.104782 15.1569 -0.00390434 15.3809 0.344523ZM17.5 9.00009V5.75009C17.5 5.61202 17.3881 5.50009 17.25 5.50009H14.25C14.1119 5.50009 14 5.61202 14 5.75009V9.00009H17.5ZM12.5 9.00009V8.00009H9.25C9.11193 8.00009 9 8.11202 9 8.25009V9.00009H12.5ZM1.5 10.5001V16.7501C1.5 17.7166 2.2835 18.5001 3.25 18.5001H16.75C17.7165 18.5001 18.5 17.7166 18.5 16.7501V10.5001H1.5Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/equipment.9bc24ed88ec711c05ca10fac4a4d912c.svg";
export { ForwardRef as ReactComponent };